<template>
  <TopNav></TopNav>
  <h1>Density Calculator</h1>
  <fieldset>
    <legend>Density Calculator</legend>
    <label for="a">Mass: </label> <input type="number" v-model.number="mass" id="a" step="any"> ㎏
    <br>
    <label for="b">Volume: </label> <input type="number" v-model.number="volume" id="b" step="any"> m<sup>3</sup>
    <br><br>
    Density = <span class="blue">{{ density() }} ㎏/m<sup>3</sup></span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Density",
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 5
      }),
      mass: 1,
      volume: 1,
    }
  },
  components: {
    TopNav
  },
  methods: {
    density: function () {
        const result = this.mass / this.volume;
        const resultNumber = Number(result);
        return this.formatter.format(resultNumber);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 110px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
